import type { FuseRouteItemType } from "@fuse/utils/FuseUtils";
import { lazyRetry } from "@utils/lazyRetry";
import { layoutConfigOnlyMain } from "@/configs/layoutConfigTemplates";
import RequireCategory from "../admin/settings/RequireCategory";

const DemoStudio = lazyRetry(() => import("./DemoStudio"));

const DemoStudioRoute: FuseRouteItemType = {
  path: "demo",
  element: (
    <RequireCategory category="agents">
      <DemoStudio />
    </RequireCategory>
  ),
  settings: { layout: layoutConfigOnlyMain },
};

export default DemoStudioRoute;
